"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationJobSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("../../types");
const types_2 = require("../types");
exports.PushNotificationJobSchema = zod_1.z.object({
    FCMToken: zod_1.z.string().optional(),
    aaid: zod_1.z.string().optional(),
    activatedOfferId: zod_1.z.string().optional(),
    appUsageAccess: zod_1.z.boolean().optional(),
    appsflyerId: zod_1.z.string().optional(),
    appInstanceId: zod_1.z.string().optional(),
    createdAt: types_1.FTimestamp,
    data: zod_1.z
        .object({
        destination: zod_1.z.string().optional(),
    })
        .optional(),
    deviceName: zod_1.z.string().optional(),
    isLimitAdTrackingEnabled: zod_1.z.boolean().optional(),
    manufacturer: zod_1.z.string().optional(),
    metadata: zod_1.z
        .object({
        activatedOfferId: zod_1.z.string().optional(),
        pushNotifType: types_2.JobHandlerFunction,
    })
        .optional(),
    model: zod_1.z.string().optional(),
    notifType: types_2.PushNotifType.optional(),
    notification: zod_1.z
        .object({
        android: zod_1.z.object({
            notification: zod_1.z.object({
                body: zod_1.z.string(),
                icon: zod_1.z.string().optional(),
                title: zod_1.z.string(),
            }),
        }),
    })
        .optional(),
    offerId: zod_1.z.string().optional(),
    os: zod_1.z.string().optional(),
    osVersion: zod_1.z.string().optional(),
    platform: zod_1.z.string().optional(),
    startTimestamp: types_1.FTimestamp,
    taskHandler: types_2.JobHandlerFunction.optional(),
    type: zod_1.z.literal(types_2.JobsType.Enum.PUSH_NOTIFICATION),
    uniqueId: zod_1.z.string().optional(), // Android only
    userId: zod_1.z.string(),
});
